import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from '@common/hooks/translation';
import KeyboardFormField from '@common/components/keyboardFormField';
import { personalFields } from '../constants/personalFields';

export const Personal = ({
  form, setForm, errors,
}) => {
  const onChange = (name, value) => {
    setForm({ ...form, [name]: value });
  };
  const t = useTranslation();

  return (
    <div className="popup-register-wide-form">
      <div className="input-wrapper">
        {personalFields.map((item) => {
          const FieldComponent = item.custumViewComponent || KeyboardFormField;
          return (
            <div key={item.name} className="register-single-input">
              {item.custumViewComponent && <div className="popup-txt">{t(item.fieldName)}</div>}
              <div className="input-row">
                <FieldComponent
                  readOnly={item.readOnly}
                  key={item.name}
                  type={item.type}
                  name={item.fieldName}
                  value={form[item.name]}
                  onChange={(value) => onChange(item.name, value)}
                  errorMessage={errors[item.name]}
                  className={item.className}
                />
              </div>
            </div>
          );
        })}
      </div>

    </div>
  );
};

Personal.propTypes = {
  form: PropTypes.object,
  setForm: PropTypes.func,
  errors: PropTypes.object,
};
